export function GetOrderStatus(status) {
    if (status == null) {
        return { value: "", label: "Unknown", class: "badge bg-light" };
    }

    if (Number(status) === 0) {
        return { value: "0", label: "Pending", class: "badge bg-warning" };
    } else if (Number(status) === 5) {
        return { value: "5", label: "Delivered", class: "badge bg-success" };
    } else if (Number(status) === 6) {
        return { value: "6", label: "Cancelled", class: "badge bg-danger" };
    } else if (Number(status) === 7) {
        return { value: "7", label: "Returned", class: "badge bg-dark" };
    } else {
        return { value: "", label: "In Process", class: "badge bg-info" };
    }

}